import { Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { usePrograms, useSessionState } from "../../api/hooks";
import { Empty, ErrorState, Loading } from "../../components/states";
import { buttonClass } from "../../components/ui/button";
import { StatusBadge } from "./status-badge";

export function ProgramList() {
  const { t } = useTranslation();
  const session = useSessionState();
  const programs = usePrograms(Boolean(session.data?.user));
  return (
    <nav aria-label={t("programs.heading")} className="flex flex-col gap-3 p-4">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">{t("programs.heading")}</h2>
        <Link to="/programs/new" className={buttonClass({ size: "sm" })}>
          <Plus className="h-4 w-4" aria-hidden />
          {t("programs.new")}
        </Link>
      </div>
      {programs.isPending ? <Loading /> : null}
      {programs.isError ? <ErrorState title={t("programs.loadFailed")} error={programs.error} onRetry={() => void programs.refetch()} /> : null}
      {programs.data?.length === 0 ? <Empty>{t("programs.empty")}</Empty> : null}
      <ul className="space-y-1">
        {programs.data?.map((program) => (
          <li key={program.id}>
            <Link
              to="/programs/$programId"
              params={{ programId: program.id }}
              className="flex flex-col gap-1 rounded-md px-3 py-2 text-sm hover:bg-accent"
              activeProps={{ className: "bg-accent" }}
            >
              <span className="line-clamp-2 font-medium">{program.title}</span>
              <StatusBadge status={program.status} kind="program" />
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
